import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { MenuItem, Typography } from '@mui/material';
import SelectField from 'shared/components/formFields/select-field';
import ViewingModeController from 'shared/components/viewing-mode-controller/viewing-mode-controller';

import { useDeviceDetailsHook } from 'features/device/device-details/hooks/device-details-hook';
import { DeviceFunction } from 'features/device/models/device-function';

const DeviceSettingsFunction = () => {
  const { t } = useTranslation('deviceDetails');

  const { currentViewingMode, currentDevice } = useDeviceDetailsHook();
  const {
    formState: { errors },
    control,
  } = useFormContext();

  const registerOptions = {
    function: {
      required: t('info.requiredHelperText'),
    },
  };

  const options = [
    <MenuItem key={'visitorPresent'} value={DeviceFunction.VisitorPresent}>
      {t('deviceFunctions.VisitorPresent')}
    </MenuItem>,
    <MenuItem key={'noVisitorPresent'} value={DeviceFunction.NoVisitorPresent}>
      {t('deviceFunctions.NoVisitorPresent')}
    </MenuItem>,
    <MenuItem key={'present'} value={DeviceFunction.PresentAndAcceptAlarms}>
      {t('deviceFunctions.PresentAndAcceptAlarms')}
    </MenuItem>,
    <MenuItem key={'absent'} value={DeviceFunction.AbsentAndHandleAlarms}>
      {t('deviceFunctions.AbsentAndHandleAlarms')}
    </MenuItem>,
  ];

  return (
    <ViewingModeController
      viewingMode={currentViewingMode}
      name="function"
      control={control}
      rules={registerOptions.function}
      render={({ field }) => (
        <SelectField
          {...field}
          variant="outlined"
          label={t('NFC.functionLabel')}
          error={!!errors.function}
          helperText={errors.function?.message?.toString()}
          className="select-field"
          value={field.value ?? ''}
        >
          {options}
        </SelectField>
      )}
      display={
        <Typography variant="subtitle1">
          {`${t('NFC.functionLabel')}: ${
            currentDevice ? t(`deviceFunctions.${currentDevice.function}`) : t(`deviceFunctions.${DeviceFunction.PresentAndAcceptAlarms}`)
          }`}
        </Typography>
      }
    />
  );
};

export default DeviceSettingsFunction;
